import api from './api';

export const matchService = {
  async getMatches() {
    const response = await api.get('/match');
    return response.data;
  },

  async getDetailedMatch(country, visaType) {
    const response = await api.get(`/match/${country}/${visaType}`);
    return response.data;
  },

  async sendChatMessage(message, context = {}) {
    const response = await api.post('/match/chat', { message, context });
    return response.data;
  },

  async extractProfile(conversation) {
    const response = await api.post('/match/extract-profile', { conversation });
    return response.data;
  }
};